<template>
  <TsMedia append-class="items-center h-full">
    <TsMediaStart>
      <TsImage :src="props.img" :alt="props.alt" height="52" width="52" loading="lazy"/>
      <TsTypography variant="sm" weight="semibold" append-class="max-w-[52px] text-black text-center">{{ props.imgDescription }}</TsTypography>
    </TsMediaStart>
    <TsMediaContent append-class="flex flex-col justify-center w-full py-4 md:py-5 bg-natural-soft-white rounded-lg px-5 h-full">
      <TsTypography as="h4" append-class="mb-0">{{ props.title }}</TsTypography>
      <TsTypography>{{ props.description }}</TsTypography>
      <TsAlert v-if="props.msg" variant="info" append-class="font-medium bg-info/10 border-l-[8px] border-primary py-2 px-3 mt-1.5 ">
        {{ props.msg }}
      </TsAlert>
    </TsMediaContent>
  </TsMedia>
</template>

<script setup lang="ts">


const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);


type Props = {
  img?: string,
  alt?: string,
  imgDescription?: string,
  title?: string,
  description?: string,
  msg?: string
}

const props = withDefaults(defineProps<Props>(), {
  img: '/images/logos/purchase_trolley.svg',
  alt: 'purchase_trolley',
  imgDescription: 'Step 1',
  title: 'Purchase',
  description: 'Check online whether your product is in stock and choose Click & Collect',
})
</script>